import React from "react";
import { ArrowLeft } from "lucide-react";
import { BRAND, HERO_STATS, HERO_IMAGE } from "../mock";

const Hero = ({ onRegister, onBook }) => {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* background */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="مسار كورنر"
          className="w-full h-full object-cover animate-slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-[#140f0a]/95 via-[#140f0a]/70 to-[#140f0a]/30" />
        <div className="absolute inset-0 bg-[#140f0a]/25" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-8 w-full pt-28 pb-16">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-stone-200 text-xs mb-6 animate-fade-up">
            <span className="w-1.5 h-1.5 rounded-full bg-[#BF9A5A]" />
            {BRAND.tagline}
          </span>

          <h1 className="font-display text-6xl lg:text-8xl font-700 text-white mb-5 animate-fade-up">
            {BRAND.name}
          </h1>

          <p className="text-lg lg:text-xl text-stone-200/90 leading-relaxed mb-6 animate-fade-up">
            برجان سكنيان قرب الحرم المكي، يرتقيان بتجربة السكن لزوار مكة وسكانها.
          </p>

          <p className="text-[#D9C08A] text-sm font-700 mb-8">{BRAND.license}</p>

          <div className="flex flex-wrap gap-3 animate-fade-up">
            <button
              onClick={onRegister}
              className="px-7 py-3.5 rounded-xl bg-[#BF9A5A] hover:bg-[#a9853f] text-white font-700 transition-all hover:shadow-xl hover:shadow-[#BF9A5A]/30"
            >
              سجل اهتمامك
            </button>
            <button
              onClick={onBook}
              className="px-7 py-3.5 rounded-xl bg-white/10 hover:bg-white/20 border border-white/30 text-white font-700 transition-colors"
            >
              احجز الآن
            </button>
            <button
              onClick={() => document.querySelector("#about")?.scrollIntoView({ behavior: "smooth" })}
              className="px-7 py-3.5 rounded-xl text-white font-700 flex items-center gap-2 hover:text-[#D9C08A] transition-colors"
            >
              تعرّف على التفاصيل <ArrowLeft size={18} />
            </button>
          </div>
        </div>

        {/* stats card */}
        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-3 max-w-3xl">
          {HERO_STATS.map((s, i) => (
            <div
              key={i}
              className="bg-white/8 backdrop-blur-md border border-white/15 rounded-2xl px-5 py-4 text-center animate-fade-up"
            >
              <div className="text-2xl font-800 text-white">{s.value}</div>
              <div className="text-xs text-stone-300 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
